import React, { useRef } from 'react';
import { TosModal } from './TosModal';
const meta = {
    title: 'Features/AIChatWidget/TosModal',
    component: TosModal
};
export default meta;
export const ViewportOverlay = {
    args: {
        isOpen: true,
        isSubmitting: false,
        anchor: undefined,
        onAccept: () => {
            console.log('TOS accepted');
        }
    }
};
export const ViewportOverlaySubmitting = {
    args: {
        isOpen: true,
        isSubmitting: true,
        anchor: undefined,
        onAccept: () => {
            console.log('TOS accepted');
        }
    }
};
export const Closed = {
    args: {
        isOpen: false,
        onAccept: () => {
            console.log('TOS accepted');
        }
    }
};
function AnchoredDemo() {
    var _a;
    const anchorRef = useRef(null);
    return (React.createElement("div", { ref: anchorRef, style: {
            position: 'relative',
            width: 480,
            height: 600,
            border: '1px solid #e5e7eb',
            borderRadius: 8,
            background: '#f9fafb',
            overflow: 'hidden'
        } },
        React.createElement("div", { style: { padding: 16, color: '#6b7280' } }, "Chat widget content behind modal"),
        React.createElement(TosModal, { isOpen: true, onAccept: () => {
                console.log('TOS accepted (anchored)');
            }, anchor: (_a = anchorRef.current) !== null && _a !== void 0 ? _a : undefined })));
}
export const Anchored = {
    render: () => React.createElement(AnchoredDemo, null)
};
